import { Lock } from 'lucide-react';
import { useLicenseLocked } from '../../services/license-status';

/**
 * Full-screen block shown once any call comes back 423 license_expired.
 *
 * Without it every action a cashier attempts fails with its own generic error
 * toast and nothing says why — the licence gate would be functional but
 * illegible. Shown to every role on purpose: at this point nothing works, so
 * saying so plainly beats a silently broken app.
 *
 * It clears itself as soon as a response comes back without the warning header
 * (i.e. right after a renewal), no reload needed.
 */
export default function LicenseLockedOverlay() {
    const message = useLicenseLocked();

    if (!message) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-900/70 backdrop-blur-sm p-4">
            <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-6 text-center">
                <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
                    <Lock className="h-6 w-6 text-red-600" />
                </div>
                <h2 className="mt-4 text-lg font-semibold text-gray-900">Licence expirée</h2>
                <p className="mt-2 text-sm text-gray-600">{message}</p>
                <p className="mt-4 text-xs text-gray-400">
                    L'accès est rétabli automatiquement dès le renouvellement, sans redémarrage.
                </p>
            </div>
        </div>
    );
}
